import Banner from "../../utilities/Banner/Banner";
import { Container, Box, Button } from "@mui/material";
import { Constants } from "../Content";
import React, { useState, useEffect } from "react";
import { ManageUsersWrapper, ActionBoxWrapper } from "./ManageUsersStyled";
import ManageUserTable from "../Tables/ManageUserTable";
import SearchInput from "../../utilities/SearchInput/SearchInput";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ViewDialog from "../ViewDialog/ViewDialog";
import { useDispatch, useSelector } from "react-redux";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import AddUserDialog from "../AddUser/AddUserDialog";
import AddRoleDialog from "../AddRole/AddRoleDialog";
import { PageName, UserRole } from "../../QuoteRequest/Content";
import { Congiguration } from "../../../Constants/AppConstants";
import {
  getAllUsersAllRoles, getLoggedUserDetails
} from "../../../Actions/UserAction";
import { Severity } from "../../utilities/Notification/NotificationContent";
import Notification from "../../utilities/Notification/Notification";
import { isJsonString } from "../../../Helper/Helper";
import { LocalStorageKeys } from "../../QuoteRequest/Content";
import { useNavigate } from "react-router-dom";
import { GET_LOGGED_USER_DETAILS } from "../../../ActionTypes/ActionTypes";

//#region Constants
const userTableHeader = [
  { id: "firstName", label: "First Name", isSortable: true },
  { id: "lastName", label: "Last Name", isSortable: true },
  { id: "email", label: "Email", isSortable: false },
  { id: "roleName", label: "Role", isSortable: true },
  { id: "isActive", label: "Status", isSortable: true },
];

const roleTableHeader = [
  { id: "roleName", label: "Role", isSortable: true },
  { id: "roleDescription", label: "Role Description", isSortable: false },
  { id: "isActive", label: "Status", isSortable: false },
  { id: "actionName", label: "Privilege", isSortable: false },
];

const ManageUsers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
 
  //#region Constant Variables
  const [isRoleEdit, setIsRoleEdit] = useState(false);
  const [isUserEdit, setIsUserEdit] = useState(false);
  const [userPageNumber, setUserPage] = useState(Constants.PAGENUMBER);
  const [rolePageNumber, setRolePage] = useState(Constants.PAGENUMBER);
  const [showPrivilege, setShowPrivilege] = useState(false);
  const [userPrivilege, setuserPrivilege] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [showaddUser, setshowaddUser] = useState(false);
  const [editData, setEditData] = useState();
  const [UsersList, setUsersList] = useState([]);
  const [AllUsersList, setAllUsersList] = useState([]);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [AllRolesList, setAllRolesList] = useState([]);
  const [searchText, setSearchText] = useState("")
  const [showalretdialog, setShowalretdialog] = useState({
    open: false,
    message: "",
  });

  const [showAddRole, setShowAddRole] = useState(false);
  //let loggedUser = isJsonString(
  //  sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
  //)
  //  ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    //  : null;    
    const useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
    const loggedUserLocalStorage = isJsonString(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) : null;
    //const crmDataLocalStorage = isJsonString(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)) ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)) : null;

    let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
    //let crmData = useSelector((state) => state?.CRMReducer?.crmData);

    if (loggedUser !== undefined && Object.keys(loggedUser).length === 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {

        loggedUser = loggedUserLocalStorage;
        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
            dispatch(getLoggedUserDetails(useremail))
                .then((response) => {
                    loggedUser = response;
                    //storing user login to reducer
                    dispatch({
                        type: GET_LOGGED_USER_DETAILS,
                        payload: response,
                    });
                })
                .catch((error) => {
                    console.log(`userEmail : ${useremail} error : ${error}`);
                });
        } else {
            //storing user login to reducer
            dispatch({
                type: GET_LOGGED_USER_DETAILS,
                payload: loggedUser,
            });
        }

    } else if (loggedUser !== undefined && Object.keys(loggedUser).length !== 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {
        loggedUser = loggedUserLocalStorage;
        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
            dispatch(getLoggedUserDetails(useremail))
                .then((response) => {
                    loggedUser = response;
                    const jsonUserData = JSON.stringify(response);
                    sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
                    //storing user login to reducer
                    dispatch({
                        type: GET_LOGGED_USER_DETAILS,
                        payload: response,
                    });
                })
                .catch((error) => {
                    console.log(`userEmail : ${useremail} error : ${error}`);
                });
        }
    }

   
    useEffect(() => {
      window.scrollTo(0, 0);
      sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, "Manage Users");
      if (loggedUser?.userRole[0]?.id !== UserRole.PRICINGTEAM && 
        loggedUser?.userRole[0]?.id !== UserRole.PRICINGMANAGER && 
        loggedUser?.userRole[0]?.id !== UserRole.PRICINGVP) {
        navigate("/pageNotfound", {state: {
          status: Congiguration.unauthorizedStatus,
      },});
        }
        document.title = "Manage Users";
    }, []);
  const customUserActions = (row) => (
    <ActionBoxWrapper>
      <IconButton aria-label="edit" onClick={() => handleUserEdit(row)}>
        <Tooltip title="Edit">
          <DriveFileRenameOutlineOutlinedIcon />
        </Tooltip>
      </IconButton>
    </ActionBoxWrapper>
  );
  //#region Functions
  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.MANAGEUSERPAGE);
    getUsersandRoles();
  }, []);
  //#region User
  const handleUserChangePage = (event, newPage) => {
    setUserPage(newPage);
  };
useEffect(()=>{
  handleUserSearch(searchText)
},[AllUsersList])
  const handleUserSearch = (text) => {
    // const currentSaveList = [...setUsersList];
    setUsersList(null);
    setSearchText(text)

    const tablesrows =
      text === ""
        ? [...AllUsersList]
        : AllUsersList.filter((item) =>
            Object.values(item).some(
              (value) =>
                typeof value === Constants.STRING &&
                value.toLowerCase().includes(text.toLowerCase())
            )
          );
    setUsersList(tablesrows);
    setUserPage(1);

    //currentSaveList()
  };

  //#endregion

  //#region Role
  const handleRoleChangePage = (event, newPage) => {
    setRolePage(newPage);
  };
  const handleRoleSearch = (text) => {
    
    setFilteredRoles(null);
    const tablesrows =
      text === ""
        ? [...AllRolesList]
        : AllRolesList.filter((item) =>
            Object.values(item).some(
              (value) =>
                typeof value === Constants.STRING &&
                value.toLowerCase().includes(text.toLowerCase())
            )
          );
    setFilteredRoles(sortRolesByPrivileges(tablesrows));
    setRolePage(1);

  };
  const handlePrivilegeView = (row) => () => {
    setShowPrivilege(true);
    setuserPrivilege(row?.privileges);
    setRoleName(row?.roleName);
  };
  const closePrivilegeView = () => {
    setShowPrivilege(false);
  };

  //#endregion
  const handleUserEdit = (data) => {
    setEditData(data);
    setIsUserEdit(true);
    setshowaddUser(true);
  };
  //#endregion
  const handleRoleEdit = (data) => {
    setEditData(data);
    setIsRoleEdit(true);
    setShowAddRole(true);
  };
  const handleAddUser = () => {
    setshowaddUser(true);
  };

  const handleAddRole = () => {
    setShowAddRole(true);
  };

  const closeAddRole = () => {
    setIsRoleEdit(false);
    setShowAddRole(false);
  };
  const handleConfirmClick = (data) => {
    if (!isRoleEdit) {
      setShowalretdialog({
        open: true,
        message: Constants.SAVENOTIFICAIONROLE,
        severity:Severity.SUCCESS
      });
    }
    setIsRoleEdit(false);
    setShowAddRole(false);
    getUsersandRoles();
  };
  const handleUserConfirmClick = (data) => {
    if (!isUserEdit) {
      setShowalretdialog({
        open: true,
        message: Constants.SAVENOTIFICAIONUSER,
      });
    }
    setIsUserEdit(false);
    setshowaddUser(false);
    getUsersandRoles();
  };
  const closeNotesDialog = () => {
    setIsUserEdit(false);
    setshowaddUser(false);
  };
  const handleOkClick = () => {
    setShowalretdialog({ open: false, message: "", severity:"" });
  };


  function getUsersandRoles() {
    dispatch(getAllUsersAllRoles()).then((data) => {
      console.log("AllUsersandRolesData", data);
      data.usersAndRoles.forEach((el) => {
        el.isActive = el.isActive ? "Active" : "Inactive";
      });
      data.rolesAndActions.forEach((el) => {
        el.isActive = el.isActive ? "Active" : "Inactive";
      });
      setUsersList(data.usersAndRoles);
      setAllUsersList(data.usersAndRoles);
      setAllRolesList(data.rolesAndActions);
      const sortedRoles = sortRolesByPrivileges(data.rolesAndActions);
      setFilteredRoles(sortedRoles.reverse());
      searchText!==""&&handleUserSearch(searchText)
    });
  }
  const sortRolesByPrivileges = (rolesAndActions) => {
    const rolesWithPrivileges = {};
    
    rolesAndActions.forEach((role) => {
      const roleId = role.roleId;
      if (!rolesWithPrivileges[roleId]) {
        rolesWithPrivileges[roleId] = {
          roleId: roleId,
          roleName: role.roleName,
          roleDescription: role.roleDescription,
          isActive: role.isActive,
          privileges: [],
        };
      }
      rolesWithPrivileges[roleId].privileges.push({
        userActionMasterId: role.userActionMasterId,
        actionName: role.actionName,
      });
    });

    return Object.values(rolesWithPrivileges);
  };
  //#endregion

  return (
    <div>
      <ManageUsersWrapper>
        <Banner
          Heading={Constants.BANNER_HEADING}
          Paragraph={Constants.BANNER_PARAGRAPH}
          showBreadcrumb={true}
          breadcrumbName={Constants.BREADCRUMB_NAME}
        />
        <Container maxWidth="xl" className="containerBottom">
          <Box className="usersTable">
            <div className="buttonTab">
              <div className="searchbar">
                <h5>{Constants.USERS}</h5>
                <SearchInput
                  placeholder={Constants.SEARCHPLACEHOLDER}
                  onSearchChange={handleUserSearch}
                />
              </div>
              <Button
                variant="contained"
                color="success"
                onClick={handleAddUser}
              >
                {Constants.ADDUSER}
              </Button>
            </div>
            <ManageUserTable
              customActions={customUserActions}
              headers={userTableHeader}
              rows={UsersList}
              pageNumber={userPageNumber}
              handleChangePage={handleUserChangePage}
              rowsPerPage={10}
            />
          </Box>
          <Box className="usersTable">
            <div className="buttonTab">
              <div className="searchbar">
                <h5>{Constants.ROLE}</h5>

              </div>
            </div>
            <ManageUserTable
              headers={roleTableHeader}
              rows={filteredRoles.slice(-10)}
              pageNumber={rolePageNumber}
              isRoleType={true}
              handleChangePage={handleRoleChangePage}
              defaultSortColumn={Constants.ROLESORTROW}
              handlePrivilege={handlePrivilegeView}
              rowsPerPage={10}
            />
          </Box>
        </Container>
      </ManageUsersWrapper>
      {showPrivilege && (
        <ViewDialog
          roleName={roleName}
          privileges={userPrivilege}
          show={showPrivilege}
          handleClose={closePrivilegeView}
        />
      )}
      {showaddUser && (
        <AddUserDialog
          show={showaddUser}
          title={Constants.ADDUSER}
          heading={Constants.ADDUSER}
          handleCancelClick={closeNotesDialog}
          handleConfirmClick={handleUserConfirmClick}
          isEdit={isUserEdit}
          editData={editData}
        />
      )}
      {showAddRole && (
        <AddRoleDialog
          show={showAddRole}
          title={Constants.ADDROLE}
          handleConfirmClick={handleConfirmClick}
          handleCancelClick={closeAddRole}
          isEdit={isRoleEdit}
          editData={editData}
        />
      )}
      {showalretdialog?.open && (
         <Notification
         open={showalretdialog?.open}
         onClose={handleOkClick}
         message={showalretdialog?.message}
         severity={showalretdialog?.severity}
       />
      )}
    </div>
  );
};

export default ManageUsers;
